module.exports = __webpack_public_path__ + "static/media/G&H-Logo_vollschwarz.825c1e24.svg";